export { firebaseConfig, firebase_instance } from './app';

export type { typeMessageHandlerFunction } from './types';
export { FirebaseMessageTypeEnum } from './types';

